import styled from 'styled-components';
import { mb } from '@lendi-ui/spacing';

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${mb('xs')}
`;
